import { render, staticRenderFns } from "./robotNav.vue?vue&type=template&id=32df7e2b&scoped=true&"
import script from "./robotNav.vue?vue&type=script&lang=js&"
export * from "./robotNav.vue?vue&type=script&lang=js&"
import style0 from "./robotNav.vue?vue&type=style&index=0&id=32df7e2b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32df7e2b",
  null
  
)

export default component.exports